import * as React from 'react';

const SvgPlay = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M26.918 15.197a1 1 0 0 1 0 1.606L10.93 28.672a1 1 0 0 1-1.596-.803V4.13a1 1 0 0 1 1.596-.803l15.99 11.869Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgPlay;
